<template>

    <van-popup
        v-model="show"
        position="bottom"
        @click-overlay="cancel"
        :close-on-click-overlay="false"
    >
        <div class="area-model">
            <van-area
                title="省市区选择"
                :area-list="areaList"
                :columns-placeholder="['请选择', '请选择', '请选择']"
                @confirm="confirm"
                @cancel="cancel"
            />
        </div>
    </van-popup>
</template>
<script>
import areaList from '../utils/area'
export default {
    name: "picker-area",
    props: ['show'],
    data() {
        return {
            areaList: areaList
        };
    },
    methods: {
        confirm (res) {
            this.$emit('confirm', res)
        },
        cancel () {
            this.$emit('cancel')
        },

    },
};
</script>
<style lang="less" scoped>
</style>